class SearchForm extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));

      // Wrap the onChange method with our local debounce function
      const debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300).bind(this);

      this.input.addEventListener("input", (event) => {
        debouncedOnChange(event);
      });
    } else {
      console.warn("[SearchForm] No search input found in element:", this);
    }

    if (!this.resetButton) {
      console.warn("[SearchForm] No reset button found in element:", this);
    } else {
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton && this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add("hidden");
    }
  }

  onChange() {
    console.log("[SearchForm] onChange triggered with query:", this.input.value);
    this.toggleResetButton();
    // Add Heap tracking event here
    if (window.heap && this.input.value.length > 0) {
      console.log("[SearchForm] Tracking input with Heap. Query:", this.input.value);
      heap.track('Search Form Input', { query: this.input.value });
    } else {
      console.warn("[SearchForm] Heap is not available on window");
    }
  }

  shouldResetForm() {
    const result = !document.querySelector('[aria-selected="true"] a');
    console.log("[SearchForm] shouldResetForm returns:", result);
    return result;
  }

  onFormReset(event) {
    console.log("[SearchForm] onFormReset called with event:", event);
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      console.log("[SearchForm] Resetting form input");
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    } else {
      console.log("[SearchForm] Not resetting form due to predictive search selection");
    }
  }
}

customElements.define("search-form", SearchForm);